import type {
  PlacementGating,
  SandmanConfig,
  SandmanConfigResponse,
  SandmanProvider,
} from "@/types/entities/campaign"

export const SANDMAN_PROVIDER_OPTIONS: {
  key: SandmanProvider
  label: string
}[] = [
  { key: "google", label: "Google" },
  { key: "microsoft", label: "Microsoft" },
  { key: "other", label: "Other" },
]

export const DEFAULT_SANDMAN_CONFIG: SandmanConfig = {
  enabled: true,
  providers: {
    google: { run: true, gate: true },
    microsoft: { run: true, gate: false },
    other: { run: true, gate: false },
  },
}

const booleanOrDefault = (value: unknown, fallback: boolean) =>
  typeof value === "boolean" ? value : fallback

export const normalizeSandmanConfig = (
  sandman?: SandmanConfigResponse | null,
  legacyGating?: Partial<PlacementGating> | null,
): SandmanConfig => {
  const hasSandman = Boolean(sandman)

  return {
    enabled: booleanOrDefault(sandman?.enabled, DEFAULT_SANDMAN_CONFIG.enabled),
    providers: SANDMAN_PROVIDER_OPTIONS.reduce<SandmanConfig["providers"]>(
      (providers, { key }) => {
        const defaults = DEFAULT_SANDMAN_CONFIG.providers[key]
        const source = sandman?.providers?.[key]
        const legacyGate =
          !hasSandman && key !== "other" ? legacyGating?.[key] : undefined

        return {
          ...providers,
          [key]: {
            run: booleanOrDefault(source?.run, defaults.run),
            gate: booleanOrDefault(source?.gate, legacyGate ?? defaults.gate),
          },
        }
      },
      {} as SandmanConfig["providers"],
    ),
  }
}
